import { Component, OnInit } from '@angular/core';
import { ReviewService } from 'src/app/services/review.service';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss']
})
export class ReviewComponent implements OnInit {
  public loading:boolean=true;
  public review;
  public reviewId;

  constructor(
    private _review: ReviewService,
    private _route: ActivatedRoute,
    private _notify: NotificationService
  ) {
    this.reviewId=this._route.snapshot.paramMap.get('id');
  }

  getReview(){
    this._review.getReview(this.reviewId).subscribe(
      res=>{
        this.review=res;
        this.loading=false;
      }
    );
  }

  approveReview(){
    this._review.approveReview(this.reviewId).subscribe(
      res=>{
        this.review=res;
        this._notify.showMessage('Review has been marked as approved.', 'OK');
      }
    );
  }

  rejectReview(){
    this._review.rejectReview(this.reviewId).subscribe(
      res=>{
        this.review=res;
        this._notify.showMessage('Review has been marked as rejected.', 'OK');
      }
    );
  }

  ngOnInit() {
    this.getReview();
  }

}
